import React from "react";

const WelcomeStep1 = ({ user, ImageModal }) => {
  return (
    <div className="welcome-modal-content">
      <div className="header-modal">
        Bienvenue sur Linksight {user.FirstName}{" "}
        <span role="img" aria-label="emoji">
          🎉
        </span>{" "}
      </div>
      <div className="content-welcome-modal">
        <p>
          Nous sommes ravis de vous accueillir dans notre communauté.{" "}
          <span role="img" aria-label="emoji">
            🤗
          </span>
        </p>
        <p>
          Partagez votre univers sur vos réseaux sociaux préférés grâce à votre
          page personnalisée.
        </p>
        <p>
          <b>Cliquez sur "Suivant"</b> pour commencer à configurer votre
          première page Linksight.
        </p>
      </div>
    </div>
  );
};

export default WelcomeStep1;
